'use strict';

angular.module('ClinicApp').config(function($stateProvider) {
  $stateProvider.state('verify-email', {
    url: '/verify-email/:requestingUser/:base64Email/:token/',
    templateUrl: '/views/verify-email.html',
    controller: 'VerifyEmailCtrl',
    resolve: {
      pageTitle: function($pageTitle) {
        $pageTitle.set('Verify Email - Opencare');
      },
    },
    data: {
      hideNavigation: true,
    },
  });
});

angular.module('ClinicApp').controller('VerifyEmailCtrl', function($scope, $stateParams, $base64, CurrentUser, UserService, GrowlService) {
  var decodedEmail = '';
  try {
    decodedEmail = $base64.decode($stateParams.base64Email);
  } catch (_e) {
    GrowlService.error('The verification email link specified was invalid.');
    $scope.emailVerificationSuccess = false;
    return;
  }
  if (!decodedEmail) {
    $scope.emailVerificationSuccess = false;
    return;
  }

  return UserService.verifyEmail(decodedEmail, $stateParams.token, $stateParams.requestingUser)
    .then(() => {
      CurrentUser.update();
      $scope.emailVerificationSuccess = true;
    })
    .catch(() => {
      $scope.emailVerificationSuccess = false;
    });
});
